import { Helmet } from 'react-helmet-async';
// sections
import CoureGroupListView from 'src/sections/course-group/view/course-list-view';


// ----------------------------------------------------------------------

export default function CourseGroupListPage() {
  return (
    <>
      <Helmet>
        <title>Dashboard: Course Group List</title>
      </Helmet>

      <CoureGroupListView />
    </>
  );
}
